module.exports = __webpack_public_path__ + "img/客服巡检@3x.9c462e14.png";